/* eslint-disable import/no-cycle */
import Http from '@/api/http';
/* eslint-enable import/no-cycle */
import Util from '@/util';

/**
 * Schnittstelle zwischen UI und Backend
 */
export default class Devtool {
    static findUserByMail(email) {
        return Http.post('/devtool/find/user', { email });
    }

    static deleteUserByMail(email, {
        inEvalanche = false,
        inCeleraone = false,
        inSalesforce = false,
    }) {
        return new Promise((resolve, reject) => {
            Http.post('/devtool/delete/user', {
                email,
                inEvalanche,
                inCeleraone,
                inSalesforce,
            })
                .then((response) => {
                    if (response.data.inCeleraone) {
                        const filename = `${email}-${response.data.celeraoneResult.userId}.json`;
                        const { data } = response.data.celeraoneResult;
                        Util.download(filename, data);
                    }
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    }
}
